import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowHeadToLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	className: "arrow-head",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 54.3 138.6",
	style: { enableBackground: "new 0 0 54.3 138.6" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			className: "arrow-head__backdrop",
			x: 2.1,
			y: 0,
			width: 50.6,
			height: 138.6
		}) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "arrow-head__space-between",
				d: "M4.3,60.9C2.8,63.5,2,66.5,2,69.4s0.8,5.9,2.3,8.5l33.6,58.2c0.5,0.9,1.1,1.7,1.8,2.5h13c-3.9,0-7.6-2.1-9.5-5.5L9.6,74.8 c-2-3.4-2-7.6,0-11L43.1,5.5c2-3.4,5.6-5.5,9.6-5.5l-13,0c-0.7,0.7-1.3,1.6-1.8,2.5l0,0l0,0L4.3,60.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "arrow-head__tip",
				d: "M52.7,138.6h1.6V0l-1.6,0c-4,0-7.6,2.1-9.6,5.5L9.6,63.8c-2,3.4-2,7.6,0,11l33.6,58.3C45.1,136.5,48.8,138.6,52.7,138.6z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "arrow-head__bg",
				d: "M0,0l0,138.5h2.1h37.6c-0.7-0.7-1.3-1.6-1.8-2.5L4.3,77.8C2.8,75.2,2,72.2,2,69.3s0.8-5.9,2.3-8.5L37.8,2.5l0,0l0,0 C38.4,1.6,39,0.8,39.6,0L2.1,0L0,0z"
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgArrowHeadToLeft);
export default ForwardRef;
